var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnterIcom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 11.7773C2 11.2864 2.39797 10.8885 2.88889 10.8885L13.5556 10.8885C15.0283 10.8885 16.2222 9.69455 16.2222 8.22179L16.2222 4.66623C16.2222 4.17531 16.6202 3.77734 17.1111 3.77734C17.602 3.77734 18 4.17531 18 4.66623L18 8.22179C18 10.6764 16.0102 12.6662 13.5556 12.6662L2.88889 12.6662C2.39797 12.6662 2 12.2683 2 11.7773Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.26035 12.4059C1.91322 12.0587 1.91322 11.4959 2.26035 11.1488L5.81591 7.59325C6.16304 7.24611 6.72585 7.24611 7.07298 7.59325C7.42012 7.94038 7.42012 8.50319 7.07298 8.85033L4.14597 11.7773L7.07298 14.7044C7.42012 15.0515 7.42012 15.6143 7.07298 15.9614C6.72585 16.3086 6.16304 16.3086 5.8159 15.9614L2.26035 12.4059Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterIcom);
export default __webpack_public_path__ + "static/media/enterIcom.defb7ea6ba1d39fa638c377b85ce67fd.svg";
export { ForwardRef as ReactComponent };